"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openexchangeratesCurrencies = exports.userCurrencies = exports.baseCurrencies = exports.UserCurrencies = exports.UserDisplayCurrencies = exports.BaseCurrencies = void 0;
// @NOTE-HF: [IMPORTANT!] Remember to update Currency in Prisma schema when updating this file
// @NOTE-AT: Currencies that can be transacted in and are accepted by Donation Providers
const openexchangerates_1 = require("./openexchangerates");
Object.defineProperty(exports, "openexchangeratesCurrencies", { enumerable: true, get: function () { return openexchangerates_1.openexchangeratesCurrencies; } });
exports.BaseCurrencies = {
    AUD: 'AUD',
    BRL: 'BRL',
    CAD: 'CAD',
    CHF: 'CHF',
    CZK: 'CZK',
    DKK: 'DKK',
    EUR: 'EUR',
    GBP: 'GBP',
    HKD: 'HKD',
    HUF: 'HUF',
    ILS: 'ILS',
    INR: 'INR',
    JPY: 'JPY',
    MXN: 'MXN',
    NOK: 'NOK',
    NZD: 'NZD',
    PLN: 'PLN',
    RON: 'RON',
    SEK: 'SEK',
    SGD: 'SGD',
    USD: 'USD',
};
// @NOTE-HF: UserDisplayCurrencies is an object of currencies that are only available on the UI and cannot be used as a payment currency
// These currencies will be converted to BaseCurrencies in the backend
exports.UserDisplayCurrencies = {
    ARS: 'ARS',
    BOB: 'BOB',
    CLP: 'CLP',
    CNY: 'CNY',
    COP: 'COP',
    CRC: 'CRC',
    IDR: 'IDR',
    KRW: 'KRW',
    KZT: 'KZT',
    PEN: 'PEN',
    PHP: 'PHP',
    THB: 'THB',
    TRY: 'TRY',
    UAH: 'UAH',
    VND: 'VND',
    ZAR: 'ZAR',
    // EGP: 'EGP',
    // JOD: 'JOD',
    // MAD: 'MAD',
};
exports.UserCurrencies = Object.assign(Object.assign({}, exports.BaseCurrencies), exports.UserDisplayCurrencies);
exports.baseCurrencies = Object.values(exports.BaseCurrencies);
exports.userCurrencies = Object.values(exports.UserCurrencies);
//# sourceMappingURL=currencies.js.map